import { useNavigate } from "react-router";
import { closeModal, openModal } from "react-url-modal";
import { useAppDispatch } from "@redux/store";
import { setShowForm } from "@redux/profile/settings/changePass/slice";
import { setShowWindow, clearErrorMessage } from "@redux/profile/authAndReg/slice";
import { FormNames, WindowNames } from "@/resources/constants";

export const useModalNavigation = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const openChildModal = (window: string, form?: string) => {
    openModal({ name: "login", params: { showWindow: window, showForm: form } });
  };

  const handleChangePass = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    dispatch(clearErrorMessage());
    dispatch(setShowWindow(WindowNames.FORGOT_PASS));
    dispatch(setShowForm(FormNames.PHONE));
    openChildModal(WindowNames.FORGOT_PASS, FormNames.PHONE);
  };

  const handleRegister = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    dispatch(setShowWindow(WindowNames.REGISTRATION));
    openChildModal(WindowNames.REGISTRATION);
  };

  const handleCode = () => {
    dispatch(setShowWindow(WindowNames.CODE));
    openChildModal(WindowNames.CODE);
  };

  const handleRegSuccess = () => {
    dispatch(setShowWindow(WindowNames.REGISTRATION_SUCCESS));
    openChildModal(WindowNames.REGISTRATION_SUCCESS);
  };

  const handleError = () => {
    dispatch(setShowWindow(WindowNames.CODE));
    openChildModal(WindowNames.CODE);
  };

  const handleAuth = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    dispatch(clearErrorMessage());
    dispatch(setShowWindow(WindowNames.AUTH));
    openChildModal(WindowNames.AUTH);
  };

  const handleEndProcess = () => {
    closeModal();
  };

  const handleClose = () => {
    navigate(-1);
  };

  return {
    handleChangePass,
    handleRegister,
    handleCode,
    handleRegSuccess,
    handleError,
    handleAuth,
    handleEndProcess,
    handleClose,
  };
};

